import { call, put, takeLatest } from 'redux-saga/effects'

import {
  postPesticideManufacturer,
  putPesticideManufacturer,
  postPesticide,
  putPesticide,
  deletePesticide
} from '@galo-monitor/services/apis/galoMonitorApi/resources/pesticide'

import { PesticideActions, PesticideTypes } from './duckPesticide'

function* savePesticideManufacturer({ manufacturer, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(
      manufacturer.id
        ? putPesticideManufacturer
        : postPesticideManufacturer,
      manufacturer
    )
    yield call(onSuccess)
  } catch (err) {
    yield put(PesticideActions.pesticideError(err.message))
    yield call(onError, err)
  }
}

function* savePesticide({ pesticide, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(pesticide.id ? putPesticide : postPesticide, pesticide)
    yield call(onSuccess)
  } catch (err) {
    yield put(PesticideActions.pesticideError(err.message))
    yield call(onError, err)
  }
}

function* removePesticide({ pesticide, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deletePesticide, pesticide)
    yield call(onSuccess)
  } catch (err) {
    yield put(PesticideActions.pesticideError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(PesticideTypes.SAVE_PESTICIDE_MANUFACTURER, savePesticideManufacturer),
  takeLatest(PesticideTypes.SAVE_PESTICIDE, savePesticide),
  takeLatest(PesticideTypes.REMOVE_PESTICIDE, removePesticide)
]
